<!-- 订购确认 -->

<template>
    <div class="package-buy-confrim">
        <app-header
            :title="$t('packages.confirm.title')"
            @on-click="goBack"
        ></app-header>

        <div class="goods-info">
            <div class="goods-name">{{ goods.goodsName }}</div>
            <div class="goods-num">x {{ urlParams.quantity }}</div>
        </div>

        <div class="payment-price-box">
            <van-cell :title="$t('packages.confirm.real_pay_amount')">
                <template>
                    <div class="price">{{ goods.goodsPriceText }}</div>
                </template>
            </van-cell>
        </div>

        <div class="payment-btn cell-box">
            <span class="fw600 online-payment" @click="onlinePayment">{{ $t('packages.confirm.online_payment') }}</span>
        </div>
    </div>
</template>

<script>
    import {  keepTwodecimalFull } from '../../utils/util'
    import { pay as payFun } from '../pay/pay'

    export default {
        name: 'PackageBuyConfirm',
        data() {
            return {
                urlParams: {
                    quantity: 1
                },
                goods: {}
            }
        },
        mounted() {
            this.urlParams = Object.assign({},this.urlParams, this.$route.query);
            // 获取套餐详情
            this.getPackageDetail(this.urlParams.goodsCode)
                .then(res => {
                    if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                        this.initData(res.data.dataList);
                    }
                })
                .catch(err => {
                    this.$toast(err)
                })
        },
        methods: {    
            goBack() {
                this.$router.go(-1);
            },     
            initData(list) {
                this.goods = list[0];                
                this.goods = {
                    ...this.goods,
                    goodsPriceText: this.doPriceStyle(this.goods, this.goods.goodsPrice * this.urlParams.quantity)                
                }
            },
            doPriceStyle(item, price) {                
                //price = keepTwodecimalFull(price/100);
                //return `${item.currencyType} ${price}`;
                return this.globalPriceFormat(item.currencyType, price);                
            },
            // 生成订单
            async createOrder(payMethod='ACCOUNT_AMOUNT') {
                let orderObj = {},
                    channelType = this.$APP_CONFIG.request.channelType;
                let params = {                    
                    channelType,
                    orderType: 'BUYPKG',
                    currencyType: this.goods.currencyType,
                    goodsList: [{
                        goodsId: this.goods.goodsId,
                        quanity: this.urlParams.quantity,
                        effectiveTime: 0,
                        expireTime: 0
                    }],
                    orderMark: '',
                    payMethod,
                    payAgreeFlag: 0
                };

                // 为家庭组下的生成订单
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    params.imei = JSON.parse(sessionStorage.getItem('urlData') || '{}')?.imei
                }

                await this.$http.post({
                    url: '/bss/app/order/CreateOrder',
                    data: {
                        ...params
                    }
                }).then(res => {
                    if(res.data && res.data.orderSN) {
                        orderObj = res.data;
                    }
                }).catch(err => {                    
                    this.$toast(err);
                });

                return orderObj;
            },
            async onlinePayment() {
                // 先要生成订单
                let orderData = await this.createOrder();
                // 如果创建订单一些数据没有拿到则返回
                if(!orderData.orderSN) {
                    this.$toast(this.$t('packages.confirm.create_order_error'));
                    return;
                }

                // 去收银台支付
                payFun({
                    orderSn: orderData.orderSN,
                    totalAmount: orderData.amount,
                    currencyCode: this.goods.currencyType,
                    orderDesc: this.goods.goodsName,
                    orderSubject: this.goods.goodsName
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    @import 'css/confirm.less';
</style>